module.exports = import("@wordpress/interactivity-router");;